import { motion } from 'framer-motion'
import React from 'react'
import '../App.css'
import ReuseSidebar from './ReuseSidebar'


// const routes = [
//   {
//     path: '/',
//     name: "Home",
//     icon: <i class="fa-solid fa-house-user"></i>
//   }

// ]

const Sidebar = ({ children, sidebar }) => {
 
  return (
    <>
      <div className="d-flex main_container">

    

      {/* ----------------------Sidebar----------------------- */}
        <motion.div className=" sidebarone   " animate={{ minWidth: sidebar ? "200px" : "45px", transition: {duration: 0.5}}}>
          <ReuseSidebar sidebar={sidebar}/>

          {/* <section className='routes'>
            {
              routes && routes.map((route) => {
                return (
                  <NavLink to={route.path} key={route.name} className="link active" >
                    <div className="icon">{route.icon}</div>
                    {
                      sidebar && <motion.div className="link_text" initial={{
                        opacity: 0,
                        transition: {
                          duration: 0.8
                        }
                      }} animate={{
                        opacity: 1,
                        transition: {
                          duration: 0.8
                        }
                      }} >{route.name}</motion.div>
                    }
                  </NavLink>
                )
              })
            }
          </section> */}

        </motion.div>

        <main className='mainClasses'>{children}</main>
      </div>

    </>
  )
}

export default Sidebar
